import { IrdProperty, IrdPropertyType } from './property';

export interface IrdEntitySchema<T> {
  primaryKey: keyof T;
  translationKeyPrefix: string;
  //backendClass?: string;
  //t_ClassName?: string
  withEditDialog?: boolean;
  properties: Record<keyof T, IrdProperty<T, IrdPropertyType>>;
}

export class IrdEntitySchemaImpl<T> implements IrdEntitySchema<T> {
  public readonly properties: Record<keyof T, IrdProperty<T, IrdPropertyType>> = {} as Record<keyof T, IrdProperty<T, IrdPropertyType>>; //TODO type conversin
  public withEditDialog: boolean = false;

  constructor(
    public readonly primaryKey: keyof T,
    public readonly translationKeyPrefix: string,
  ) {}
}
